import { z } from 'zod';
import { ImportCsvSearchSchema } from '@/features/import-csv/zod-schemas';

/** サブスク時のみ使用。契約 / テナント / CSV のどのインポートか */
const SubscriptionPhaseSchema = z.enum(['contract', 'tenant', 'plan']);
export type SubscriptionPhase = z.infer<typeof SubscriptionPhaseSchema>;
export const ContractImportCsvSearchSchema = ImportCsvSearchSchema.extend({
  /** サブスクリプション契約インポート時に必須。契約・テナント・CSVのどれか */
  phase: SubscriptionPhaseSchema.optional()
});
export type ContractImportCsvSearchParams = z.infer<typeof ContractImportCsvSearchSchema>;